import type { GetPolicyResponseTypeV2 } from '@clearcover/core-app-types';
import type { ReasonKey } from 'BlockList/types';
import type { BatchCreateBlockedAttributePayload } from 'Shared/services/Reznor/PostBlockListAttributesBatch';

export const buildBatchPayloadFromPolicy = (
  policy: GetPolicyResponseTypeV2,
  reason: ReasonKey,
  notes: string
): BatchCreateBlockedAttributePayload => {
  const policyId = policy.policyDetails.policyId;
  const policyNumber = policy.policyDetails.policyNumber;

  const sharedFields = {
    reason,
    notes,
    policy_id: policyId,
    policy_number: policyNumber,
  };

  const attributes: BatchCreateBlockedAttributePayload['attributes'] = [];

  const email = policy.policyHolder.contactInfo.email?.trim() ?? '';
  if (email) {
    attributes.push({
      attribute_type: 'email',
      attribute_values: { email },
      ...sharedFields,
    });
  }

  const cellPhone = policy.policyHolder.contactInfo.cellPhone?.trim() ?? '';
  const homePhone = policy.policyHolder.contactInfo.homePhone?.trim() ?? '';
  const phone = cellPhone || homePhone;
  if (phone) {
    attributes.push({
      attribute_type: 'phone_number',
      attribute_values: { phone_number: phone },
      ...sharedFields,
    });
  }

  const allDrivers = [
    ...(policy.drivers ?? []),
    ...(policy.excludedDrivers ?? []),
  ];
  for (const driver of allDrivers) {
    const firstName = driver.person.name.firstName?.trim() ?? '';
    const lastName = driver.person.name.lastName?.trim() ?? '';
    const dob = driver.person.dateOfBirth?.trim() ?? '';
    if (firstName && lastName && dob) {
      attributes.push({
        attribute_type: 'name_dob',
        attribute_values: { first_name: firstName, last_name: lastName, dob },
        ...sharedFields,
      });
    }
  }

  for (const driver of policy.drivers ?? []) {
    const state = driver.driversLicense?.state?.trim() ?? '';
    const number = driver.driversLicense?.number?.trim() ?? '';
    if (state && number) {
      attributes.push({
        attribute_type: 'drivers_license',
        attribute_values: { state, number },
        ...sharedFields,
      });
    }
  }

  for (const vehicle of policy.vehicles ?? []) {
    const vin = vehicle.vin?.trim() ?? '';
    if (vin) {
      attributes.push({
        attribute_type: 'vin',
        attribute_values: { vin },
        ...sharedFields,
      });
    }
  }

  return { attributes };
};
